export const historyData = [
    {
        img: '/cell/check.png',
        name: 'Remittance',
        date: '3rd Nov 2023',
        amount: '₦30,000.00'
    },
    {
        img: '/cell/check.png',
        name: 'Remittance',
        date: '3rd Nov 2023',
        amount: '₦30,000.00'
    },
    {
        img: '/cell/check.png',
        name: 'Remittance',
        date: '3rd Nov 2023',
        amount: '₦30,000.00'
    },
    {
        img: '/cell/check.png',
        name: 'Remittance',
        date: '3rd Nov 2023',
        amount: '₦30,000.00'
    },
    {
        img: '/cell/check.png',
        name: 'Remittance',
        date: '3rd Nov 2023',
        amount: '₦30,000.00'
    },
]


export const cellmembers = [
    {
        no: 'No 1 of 9',
        name: 'Obiabo Immanuel',
        amount: '₦300,000.00',
        last: '3rd Nov 2023',
        next: '3rd Nov 2023',
        status: 'Pending'
    },
    {
        no: 'No 2 of 9',
        name: 'Obiabo Immanuel',
        amount: '₦300,000.00',
        last: '3rd Nov 2023',
        next: '3rd Nov 2023',
        status: 'Pending'
    },
    {
        no: 'No 3 of 9',
        name: 'Obiabo Immanuel',
        amount: '₦300,000.00',
        last: '3rd Nov 2023',
        next: '3rd Nov 2023',
        status: 'Pending'
    },
    {
        no: 'No 4 of 9',
        name: 'Obiabo Immanuel',
        amount: '₦300,000.00',
        last: '3rd Nov 2023',
        next: '3rd Nov 2023',
        status: 'Pending'
    },
    {
        no: 'No 5 of 9',
        name: 'Obiabo Immanuel',
        amount: '₦300,000.00',
        last: '3rd Nov 2023',
        next: '3rd Nov 2023',
        status: 'Pending'
    },
]



export const loanHistoryData = [
    {
        history: 'Remittance',
        icon: '/loan/remitt.png',
        date: '3rd Nov 2023',
        amount: '₦30,000.00',
        status: 'Pending'
    },
    {
        history: 'Remittance',
        icon: '/loan/remitt.png',
        date: '3rd Nov 2023',
        amount: '₦30,000.00',
        status: 'Pending'
    },
    {
        history: 'Remittance',
        icon: '/loan/remitt.png',
        date: '3rd Nov 2023',
        amount: '₦30,000.00',
        status: 'Pending'
    },
    {
        history: 'Remittance',
        icon: '/loan/remitt.png',
        date: '3rd Nov 2023',
        amount: '₦30,000.00',
        status: 'Pending'
    },
    {
        history: 'Remittance',
        icon: '/loan/remitt.png',
        date: '3rd Nov 2023',
        amount: '₦30,000.00',
        status: 'Pending'
    },
    {
        history: 'Remittance',
        icon: '/loan/remitt.png',
        date: '3rd Nov 2023',
        amount: '₦30,000.00',
        status: 'Pending'
    },
]



export const dataWallet = [
    {
        header: 'Transaction Summary',
        details: [
            {
                key: 'Transaction ID',
                details: '#BAN123456789'
            },
            {
                key: 'Transaction Date',
                details: '4th Sept, 2024 | 00:00:00'
            },
            {
                key: 'Wallet Type',
                details: 'Loan Wallet'
            },
        ]
    },
    {
        header: 'Receiver Details',
        details: [
            {
                key: 'Name',
                details: 'John Adebayo'
            },
            {
                key: 'Phone Number',
                details: '+234 802 345 6789'
            },
            {
                key: 'Bank Account',
                details: '0123456789 | Zenith Bank'
            },
        ]
    },
    {
        header: 'Additional Information',
        details: [
            {
                key: 'Transaction Reference',
                details: 'BAN-TXN-5678XYZ'
            },
            {
                key: 'Processing Fee',
                details: '₦500.00'
            },
            {
                key: 'Remark',
                details: 'Loan Disbursed to John Adebayo'
            },
        ]
    },
]
